export const CompFactorNames: {[key: string]: string} = {
    additionalIncome: 'additionalIncome',
    aircraftType: 'aircraftType',
    annualBonus: 'annualBonus',
    annualHotelRevenue: 'annualHotelRevenue',
    annualHotelRevenueCurrency: 'annualHotelRevenueCurrency',
    annualSalesCommissions: 'annualSalesCommissions',
    annualSalesCommissionsCurrency: 'annualSalesCommissionsCurrency',
    annualSalesVolume: 'annualSalesVolume',
    annualStoreRevenue: 'annualStoreRevenue',
    annualStoreRevenueCurrency: 'annualStoreRevenueCurrency',
    assetsManaged: 'assetsManaged',
    assetsManagedCurrency: 'assetsManagedCurrency',
    averageSalePrice: 'averageSalePrice',
    averageSalePriceCurrency: 'averageSalePriceCurrency',
    averageSizeCompetitor: 'averageSizeCompetitor',
    avgRoomRate: 'avgRoomRate',
    avgRoomRateCurrency: 'avgRoomRateCurrency',
    budgetUnderManagement: 'budgetUnderManagement',
    budgetUnderManagementCurrency: 'budgetUnderManagementCurrency',
    certifications: 'certifications',
    city: 'city',
    companySales: 'companySales',
    companySalesCurrency: 'companySalesCurrency',
    country: 'country',
    currency: 'currency',
    degrees: 'degrees',
    employerProductActivity: 'employerProductActivity',
    filingStatus: 'filingStatus',
    governmentContractor: 'governmentContractor',
    gradeSchedule: 'gradeSchedule',
    gradeTaught: 'gradeTaught',
    highestDegreeEarned: 'highestDegreeEarned',
    hospitalBedSize: 'hospitalBedSize',
    hospitalSetting: 'hospitalSetting',
    hotelService: 'hotelService',
    hotelType: 'hotelType',
    hourlyPay: 'hourlyPay',
    hoursPerWeek: 'hoursPerWeek',
    industry: 'industry',
    internalJobTitle: 'internalJobTitle',
    jobCode: 'jobCode',
    jobResponsibilities: 'jobResponsibilities',
    jobTitle: 'jobTitle',
    laborMarketCustomGroup1: 'laborMarketCustomGroup1',
    laborMarketCustomGroup2: 'laborMarketCustomGroup2',
    laborMarketDisplayName: 'laborMarketDisplayName',
    loanPortfoliosManaged: 'loanPortfoliosManaged',
    managementRole: 'managementRole',
    martindaleHubbellRating: 'martindaleHubbellRating',
    monthlyHoursPerWeek: 'monthlyHoursPerWeek',
    monthlyPay: 'monthlyPay',
    numberOfLawyers: 'numberOfLawyers',
    numberOfPartners: 'numberOfPartners',
    numberSupervised: 'numberSupervised',
    organizationType: 'organizationType',
    overtimeHours: 'overtimeHours',
    overtimeRate: 'overtimeRate',
    payType: 'payType',
    peopleManagementTasks: 'peopleManagementTasks',
    peopleTypesManaged: 'peopleTypesManaged',
    physicianPracticingStatus: 'physicianPracticingStatus',
    pilotCertificate: 'pilotCertificate',
    pilotCertificateClass: 'pilotCertificateClass',
    portfoliosManaged: 'portfoliosManaged',
    portfoliosManagedCurrency: 'portfoliosManagedCurrency',
    practiceArea: 'practiceArea',
    profitShare: 'profitShare',
    profitShareCurrency: 'profitShareCurrency',
    publicationCirculation: 'publicationCirculation',
    publicationFrequency: 'publicationFrequency',
    region: 'region',
    salaryHoursPerWeek: 'salaryHoursPerWeek',
    salesCommissionCurrency: 'salesCommissionCurrency',
    salesCommissionRate: 'salesCommissionRate',
    salesCommissionYearlySales: 'salesCommissionYearlySales',
    salesCustomerType: 'salesCustomerType',
    salesQuotaPercentage: 'salesQuotaPercentage',
    salesTerritory: 'salesTerritory',
    securityClearanceStatus: 'securityClearanceStatus',
    securityClearanceType: 'securityClearanceType',
    signingAuthority: 'signingAuthority',
    signingAuthorityAmountAuthorized: 'signingAuthorityAmountAuthorized',
    signingAuthorityAmountAuthorizedCurrency: 'signingAuthorityAmountAuthorizedCurrency',
    skills: 'skills',
    state: 'state',
    stockExchangeListing: 'stockExchangeListing',
    storesManaged: 'storesManaged',
    tasks: 'tasks',
    tenured: 'tenured',
    travelFrequency: 'travelFrequency',
    travelPercentage: 'travelPercentage',
    travelType: 'travelType',
    ventureCapitalFocus: 'ventureCapitalFocus',
    ventureCapitalType: 'ventureCapitalType',
    weeklyTips: 'weeklyTips',
    workShift: 'workShift',
    yearlyPay: 'yearlyPay',
    yearsExperience: 'yearsExperience',
    yearsMinimum: 'yearsMinimum',
};
